module.exports = __webpack_public_path__ + "img/quick-label-print-en.ae4d1d8f.jpg";